if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

if (typeof Shopify.theme.productVariants === 'undefined') {
  Shopify.theme.productVariants = {
    listen: () => {
      let variantSelects = document.querySelectorAll('.product-form-quick-add .product-card--variants-select');
      variantSelects.forEach(variantSelect => {
        let optionsWrapper = variantSelect.closest('.product-form-quick-add').querySelector('.product-card--options');
        let submitBtn = variantSelect.closest('.product-form-quick-add').querySelector('.add-to-cart-button');
        let options = optionsWrapper.querySelectorAll('.product-card--option select');

        if (options.length == 2) {
          let firstSelect = options[0];
          firstSelect.addEventListener('change', () => {
            let changedOptionType = firstSelect.getAttribute('data-option-title').toLowerCase();
            let variantsByOption = variantSelect.querySelectorAll(`option[data-option--${changedOptionType}="${firstSelect.value}"]`);
            let secondSelect = options[1];
            secondSelect.selectedIndex = 0;

            if (submitBtn) {
              submitBtn.setAttribute('disabled', '');
            }

            let secondOptionType = secondSelect.getAttribute('data-option-title').toLowerCase();
            secondSelect.querySelectorAll('option').forEach(secondOption => {
              secondOption.setAttribute('disabled', '');
            });
            secondSelect.querySelectorAll('option').forEach(secondOption => {
              variantsByOption.forEach(variantOption => {
                if (secondOption.textContent == variantOption.getAttribute(`data-option--${secondOptionType}`)) {
                  if (!variantOption.hasAttribute('disabled')) {
                    secondOption.removeAttribute('disabled');
                  }
                }
              });
            });
            secondSelect.addEventListener('change', () => {
              if (firstSelect.value && secondSelect.value) {
                let selectedVariant = variantSelect.querySelector(`option[data-option--${changedOptionType}="${firstSelect.value}"][data-option--${secondOptionType}="${secondSelect.value}"]`);

                if (selectedVariant) {
                  variantSelect.value = selectedVariant.getAttribute('value');
                }

                if (submitBtn) {
                  submitBtn.removeAttribute('disabled');
                }
              }
            });
          });
        }
      });
    },
    showForm: () => {
      let showFormBtns = document.querySelectorAll('.js-trigger-product-form');
      showFormBtns.forEach(showBtn => {
        let productForm = showBtn.closest('.product-card__add-to-cart').querySelector('.product-form');
        let productCard = showBtn.closest('.product-card');
        let formAddToCartBtn = productForm.querySelector('[data-add-to-cart');

        if (productForm) {
          showBtn.addEventListener('click', () => {
            if (formAddToCartBtn) {
              formAddToCartBtn.textContent = 'Add to cart';
            }

            productCard.classList.add('open-form');
            productCard.style.height = 'auto';
            productForm.classList.remove('hidden');
            showBtn.classList.add('hidden');
          });
        }
      });
    },
    displayCard: () => {
      let productCards = document.querySelectorAll('.product-card');
      productCards.forEach(card => {
        card.style.height = card.offsetHeight + 'px';
        card.setAttribute('data-height', card.offsetHeight + 'px');
        let productCardLink = card.querySelector('.product-card--link');

        if (productCardLink) {
          productCardLink.style.height = productCardLink.offsetHeight + 'px';
        }
      });
    }
  };
  Shopify.theme.productVariants.listen();
  Shopify.theme.productVariants.displayCard();
  Shopify.theme.productVariants.showForm();
}
